import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, PublicacaoDiarioOficialReducer, PublicacaoDiarioOficialState } from './publicacao-diario-oficial-reducer';
import moment from 'moment';
import { IPreviewPublicationRequest } from '../../../../model/official-daily/request/preview-publication-request';
import dayjs from 'dayjs';

const PublicacaoDiarioOficialContext = createContext<PublicacaoDiarioOficialState | undefined>(undefined);
const PublicacaoDiarioOficialContextDispatchContext = createContext({} as any);

const PublicacaoDiarioOficialProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(PublicacaoDiarioOficialReducer, { previewPublicationRequest: { republication: false, publicationDateOn: dayjs().format("YYYY-MM-DD"),notes:"", description:"",descriptionCommission:"",descriptionPresidentCommission:"" } as IPreviewPublicationRequest, activeStep: 0,tabIndexForm:0, tabIndePreview:0, completed:{},files:[] as  File[] } as PublicacaoDiarioOficialState);

    return (
        <PublicacaoDiarioOficialContext.Provider value={state}>
            <PublicacaoDiarioOficialContextDispatchContext.Provider value={dispatch}>
                {children}
            </PublicacaoDiarioOficialContextDispatchContext.Provider>
        </PublicacaoDiarioOficialContext.Provider>
    );
}

const usePublicacaoDiarioOficialState = () => {
    const context = useContext(PublicacaoDiarioOficialContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const usePublicacaoDiarioOficialDispatch = () => {
    const context = useContext(PublicacaoDiarioOficialContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { PublicacaoDiarioOficialProvider, usePublicacaoDiarioOficialDispatch, usePublicacaoDiarioOficialState, ACTION_TYPES };
